'use-strict';

import angular from 'angular';
import { MonitoringAPIService } from 'shared/api/monitoring-api.service';
import { Task } from 'src/app/@shared-types/event-monitoring';

export class TasksService {
  private monitoringApiService: MonitoringAPIService;

  constructor(monitoringApiService: MonitoringAPIService) {
    'ngInject';

    this.monitoringApiService = monitoringApiService;
  }

  /**
   * Returns the last 5 open tasks for the current user.
   * Also returns the total number of open tasks.
   *
   * @returns {Promise <object | Error>}
   */
  public getOpenTasks = (): Promise<{
    total: number,
    tasks: Task[],
  }> => new Promise((resolve, reject) => {
    this.monitoringApiService.apiGetOpenTasks()
      .then((tasks) => resolve({
        total: tasks.length,
        tasks,
      }))
      .catch((e) => reject(e));
  });
}

export default angular.module('services.tasksService', [])
  .service('tasksService', TasksService)
  .name;
